// Version : 0.0.1
// Author : SATHISH
// LastEdit : KARTHEESWARAN
// MODFIED DATE:26-08-2025
const AccountType = {
	/*****************  GET ACCOUNT LIST START  *******************/
	GET_ACCOUNT_LIST_START: 'get_account_list_start',
	GET_ACCOUNT_LIST_SUCCESS: 'get_account_list_success',
	GET_ACCOUNT_LIST_FAILURE: 'get_account_list_failure',
	GET_ACCOUNT_LIST_RESPONSE_RESET: 'get_account_list_response_reset',
	GET_ACCOUNT_LIST_RESPONSE_CHANGED: 'get_account_list_response_changed',
	/*****************  GET ACCOUNT LIST END  *******************/

	/*****************  ADD ACCOUNT DETAILS START  *******************/
	ADD_ACCOUNT_DETAILS_START: 'add_account_details_start',
	ADD_ACCOUNT_DETAILS_SUCCESS: 'add_account_details_success',
	ADD_ACCOUNT_DETAILS_FAILURE: 'add_account_details_failure',
	ADD_ACCOUNT_DETAILS_RESPONSE_RESET: 'add_account_details_response_reset',
	ADD_ACCOUNT_DETAILS_RESPONSE_CHANGED: 'add_account_details_response_changed',
	/*****************  ADD ACCOUNT DETAILS END  *******************/

	/*****************  UPDATE ACCOUNT DETAILS START  *******************/
	UPDATE_ACCOUNT_DETAILS_START: 'update_account_details_start',
	UPDATE_ACCOUNT_DETAILS_SUCCESS: 'update_account_details_success',
	UPDATE_ACCOUNT_DETAILS_FAILURE: 'update_account_details_failure',
	UPDATE_ACCOUNT_DETAILS_RESPONSE_RESET: 'update_account_details_response_reset',
	UPDATE_ACCOUNT_DETAILS_RESPONSE_CHANGED: 'update_account_details_response_changed',
	/*****************  UPDATE ACCOUNT DETAILS END  *******************/

	/*****************  DELETE ACCOUNT DETAILS START  *******************/
	DELETE_ACCOUNT_DETAILS_START: 'delete_account_details_start',
	DELETE_ACCOUNT_DETAILS_SUCCESS: 'delete_account_details_success',
	DELETE_ACCOUNT_DETAILS_FAILURE: 'delete_account_details_failure',
	DELETE_ACCOUNT_DETAILS_RESPONSE_RESET: 'delete_account_details_response_reset',
	DELETE_ACCOUNT_DETAILS_RESPONSE_CHANGED: 'delete_account_details_response_changed',
	/*****************  DELETE ACCOUNT DETAILS END  *******************/
};
export default AccountType;
